"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BadgeComponent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var BadgeComponent = exports.BadgeComponent = _styledComponents["default"].span.attrs({
  className: 'fuse-badge'
}).withConfig({
  displayName: "badge__BadgeComponent",
  componentId: "sc-qd8nsg-0"
})(["display:inline-block;border-radius:var(--spacing-global-space3);background-color:var(--color-brand-mid);color:var(--color-global-white);font:var(--font-weight-paragraph) var(--font-size-m2) / var(--font-line-height-m2) var(--font-brand);height:var(--spacing-global-space5);line-height:var(--spacing-global-space5);min-height:var(--spacing-global-space5);min-width:var(--spacing-global-space5);padding:0 var(--spacing-global-space2);text-align:center;"]);
var _default = exports["default"] = BadgeComponent;